export default __webpack_public_path__ + "static/media/horizontal-image.0cb4d9a7.png";